/* eslint-disable @typescript-eslint/no-explicit-any */

import { DIYMasterTypes } from "./diy-master-types";


export class DIYMaster {
    assetType: DIYMasterTypes;
    previewImage: string;
    relativeUrl: string;
    constructor(data: any){
        this.assetType = typeof data.assetType!=='undefined' ? data.assetType : DIYMasterTypes.HTML5Banner;
        this.previewImage = typeof data.previewImage !=='undefined' ? data.previewImage : ''
        this.relativeUrl = typeof data.relativeUrl !=='undefined' ? data.relativeUrl : '/production'
    }
}